import { FC } from 'react';
import { clsx } from 'clsx';

import { LinkButton, UIHeading1 } from '@cian/ui-kit';

import * as style from './style.css';

interface IMotivationMobileProps {
  url: string;
  isBottom?: boolean;
  onClick: (buttonName: string) => void;
}

export const MotivationMobile: FC<IMotivationMobileProps> = ({ isBottom, url, onClick }) => {
  return (
    <div className={clsx(style['container'], isBottom && style['container-bottom'])}>
      <div className={clsx(style['wrapper'], isBottom && style['wrapper-bottom'])}>
        <div className={style['title']}>
          <UIHeading1>
            {' '}
            В приложении&nbsp;—
            <br />
            быстрее и&nbsp;удобнее!
          </UIHeading1>
        </div>
        <div className={clsx(style['content'], isBottom && style['content-bottom'])}>
          <div className={clsx(style['phone'], isBottom && style['phone-bottom'])}></div>
        </div>
      </div>
      <div className={style['btn']}>
        <LinkButton
          theme="fill_secondary"
          size="L"
          fullWidth
          href={url}
          onClick={() => onClick(isBottom ? 'footer_download_app' : 'header_download_app')}
        >
          Скачать приложение
        </LinkButton>
      </div>
    </div>
  );
};
